export enum MediaQueries {
  Mobile = '(max-width: 767px)',
  Tablet = '(min-width: 768px) and (max-width: 1439px)',
  Desktop = '(min-width: 1440px)',
}
